import {createAction} from '@reduxjs/toolkit'
import {
  UsersAndGroupsLastEvaluatedKeyTypes,
  SearchUsersGroupsItem,
  UserGroupDetailsState,
  ShowUserGroupDetailPayload,
  GetImportStatusResponse,
} from 'interfaces'
const getLink = createAction('getLink')
const getLinkFailure = createAction<string>('getLinkFailure')
const getLinkSuccess = createAction<{
  url: string
  message: string
  notifier_type: string
  sns_topic: string
}>('getLinkSuccess')

const getImportStatus = createAction('getImportStatus')
const getImportStatusFailure = createAction<string>('getImportStatusFailure')
const getImportStatusSuccess = createAction<GetImportStatusResponse>(
  'getImportStatusSuccess',
)

const getGroupsUsers = createAction('getGroupsUsers')
const getGroupsUsersFailure = createAction<string>('getGroupsUsersFailure')
const getGroupsUsersSuccess = createAction<{
  users: {
    message: string
    body?: {
      Items: {
        emailId: string
        name: string
        groupNames: string[]
      }[]
      LastEvaluatedKey: {
        emailId: string
        tenantId: string
      }
    }
  }
  groups: {
    message: string
    body?: {
      Items: {
        membersCount: string
        emailId: string
        name: string
      }[]
      LastEvaluatedKey: {
        emailId: string
        tenantId: string
      }
    }
  }
  importStatus: GetImportStatusResponse
}>('getGroupsUsersSuccess')

const getGroups = createAction<{qs?: UsersAndGroupsLastEvaluatedKeyTypes}>(
  'getGroups',
)
const getGroupsFailure = createAction<string>('getGroupsFailure')
const getGroupsSuccess = createAction<{
  message: string
  body?: {
    Items: {
      membersCount: string
      emailId: string
      name: string
    }[]
    LastEvaluatedKey: {
      emailId: string
      tenantId: string
    }
  }
}>('getGroupsSuccess')

const getUsers = createAction<{qs?: UsersAndGroupsLastEvaluatedKeyTypes}>(
  'getUsers',
)
const getUsersFailure = createAction<string>('getUsersFailure')
const getUsersSuccess = createAction<{
  message: string
  body?: {
    Items: {
      emailId: string
      name: string
      groupNames: string[]
    }[]
    LastEvaluatedKey: {
      emailId: string
      tenantId: string
    }
  }
}>('getUsersSuccess')

const getSearchUsersGroups = createAction<{
  text: string
  models: string[]
}>('getSearchUsersGroups')
const getSearchUsersGroupsFailure = createAction<string>(
  'getSearchUsersGroupsFailure',
)
const getSearchUsersGroupsSuccess = createAction<SearchUsersGroupsItem[]>(
  'getSearchUsersGroupsSuccess',
)
const resetUsersGroups = createAction('resetUsersGroups')
const resetSearch = createAction('resetSearch')
const setShowUserGroupDetails = createAction<ShowUserGroupDetailPayload>(
  'setShowUserGroupDetails',
)
const getUserGroupDetails = createAction<string>('getUserGroupDetails')
const getUserGroupDetailsSuccess = createAction<UserGroupDetailsState>(
  'getUserGroupDetailsSuccess',
)
const getUserGroupDetailsFailure = createAction<string>(
  'getUserGroupDetailsFailure',
)
export {
  getLink,
  getLinkFailure,
  getLinkSuccess,
  getGroupsUsers,
  getGroupsUsersFailure,
  getGroupsUsersSuccess,
  getImportStatus,
  getImportStatusFailure,
  getImportStatusSuccess,
  getSearchUsersGroups,
  getSearchUsersGroupsFailure,
  getSearchUsersGroupsSuccess,
  resetSearch,
  getGroups,
  getGroupsFailure,
  getGroupsSuccess,
  getUsers,
  getUsersFailure,
  getUsersSuccess,
  resetUsersGroups,
  setShowUserGroupDetails,
  getUserGroupDetails,
  getUserGroupDetailsSuccess,
  getUserGroupDetailsFailure,
}
